var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", {
    ref: "root",
    class: { "full-width": _vm.fullWidth },
    attrs: { "data-markdown-statement": "", html: _vm.html },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }